export enum ProjectEmployeeCountRangeEnum {
    'ECR_1_9' = '1-9',
    'ECR_10_24' = '10-24',
    'ECR_25_249' = '25-249',
    'ECR_250PLUS' = '250+',
}
